<template>
  <div>
    <v-select
      :label="$t('addShooting.selectStamp')"
      v-model="selectedStamp"
      return-object
      item-value="id"
      item-text="name"
      :items="stamps"
      clearable
      @input="update"
      :rules="select"
    ></v-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SelectStamp',

  computed: {
    ...mapState({
      format: (state) => state.newShooting.format,
      stamps: (state) => state.stamps,
      stamp: (state) => state.newShooting.stamp
    }),
    select() {
      return [(v) => !!v || this.$t('rooms.form.required')]
    }
  },

  data() {
    return {
      selectedStamp: null
    }
  },

  methods: {
    update(val) {
      this.$store.commit('UPDATE_STAMP', val)
    }
  },

  watch: {
    format() {
      this.selectedStamp = null
    },
    stamp: {
      immediate: true,
      handler(val) {
        this.selectedStamp = val || null
      }
    }
  }
}
</script>

<style lang="sass" scoped>
p
  text-align: center
  font-size: 16px
  color: rgba(0, 0, 0, 0.7)
</style>
